module.exports = __webpack_public_path__ + "static/img/SketchPng721e44489f2ce436e5cccb2bfdd516a69aacff58125c5585a06d55ca79705a43.bee2868a.png";